var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasterCardLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 20,
    viewBox: "0 0 33 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3516 2.13672H20.9649V17.8586H11.3516V2.13672Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3411 10.0006C12.3399 8.48668 12.6826 6.99236 13.3434 5.6307C14.0041 4.26903 14.9655 3.07569 16.1548 2.141C14.6818 0.981839 12.9128 0.261028 11.05 0.0609433C9.18718 -0.139141 7.30574 0.189575 5.62068 1.00952C3.93563 1.82947 2.51495 3.10756 1.52102 4.69773C0.527087 6.28791 0 8.126 0 10.0019C0 11.8779 0.527087 13.716 1.52102 15.3061C2.51495 16.8963 3.93563 18.1744 5.62068 18.9943C7.30574 19.8143 9.18718 20.143 11.05 19.9429C12.9128 19.7428 14.6818 19.022 16.1548 17.8629C14.9651 16.9279 14.0035 15.7341 13.3428 14.3719C12.682 13.0097 12.3395 11.5149 12.3411 10.0005V10.0006Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3126 10.0006C32.3125 11.8767 31.7853 13.7149 30.7912 15.3051C29.7971 16.8954 28.3762 18.1734 26.6909 18.9933C25.0057 19.8131 23.124 20.1416 21.2611 19.9412C19.3982 19.7408 17.6292 19.0197 16.1562 17.8601C17.3451 16.9246 18.3062 15.7309 18.9671 14.3692C19.628 13.0075 19.9714 11.5132 19.9714 9.9992C19.9714 8.48518 19.628 6.99094 18.9671 5.6292C18.3062 4.26746 17.3451 3.0738 16.1562 2.13827C17.6292 0.978741 19.3982 0.257571 21.2611 0.0571949C23.124 -0.143181 25.0057 0.185323 26.6909 1.00516C28.3762 1.82499 29.7971 3.10307 30.7912 4.69331C31.7853 6.28354 32.3125 8.12176 32.3126 9.99784V10.0006Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCardLogo);
export default __webpack_public_path__ + "static/media/master_card_logo.8a5d9d50ef951c46c89951175c0416f6.svg";
export { ForwardRef as ReactComponent };